/*
 * Copyright 2026 The Kubeflow Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { CSSProperties } from 'react';
import { Handle, Position } from '@xyflow/react';

const hiddenHandleStyle: CSSProperties = {
  border: 0,
  height: '1px',
  minHeight: '1px',
  minWidth: '1px',
  opacity: 0,
  pointerEvents: 'none',
  width: '1px',
};

function ReadOnlyNodeHandle({ type, position }: { type: 'source' | 'target'; position: Position }) {
  return (
    <Handle
      type={type}
      position={position}
      isConnectable={false}
      isConnectableStart={false}
      isConnectableEnd={false}
      style={hiddenHandleStyle}
    />
  );
}

export function ReadOnlyNodeHandles() {
  return (
    <>
      <ReadOnlyNodeHandle type='target' position={Position.Top} />
      <ReadOnlyNodeHandle type='source' position={Position.Bottom} />
    </>
  );
}
